import { Injectable } from "@angular/core";
import { NativeDateAdapter } from "@angular/material/core";

@Injectable() export class FormDateAdapter extends NativeDateAdapter{
    getFirstDayOfWeek(): number {
        return 1;
      }
}

export const DATE_FORMAT = {}